import * as z from 'zod';

import { preferredRelationsShipsQuerySchema } from './preferred-relationships-query-schema';

export const preferredRelationsShipsUpdateSchema = preferredRelationsShipsQuerySchema
  .pick({ id: true, name: true })
  .extend({ status: z.string() });

export type PreferredRelationsShipsUpdateSchema = z.infer<typeof preferredRelationsShipsUpdateSchema>;

export const preferredRelationsShipsCreateSchema = preferredRelationsShipsUpdateSchema.omit({
  id: true,
});

export type PreferredRelationsShipsCreateSchema = z.infer<typeof preferredRelationsShipsCreateSchema>;
